module.exports = __webpack_public_path__ + "img/rate_silver.fd7cfd65.jpg";